import styled from 'styled-components'

import Modal from 'components/Modal'
import Button from 'components/Button'
import Spinner from 'components/Spinner'

type Props = {
  title: string
  description: string
  isModalOpen: boolean
  onModalClose: () => void
  onModalConfirmation: () => void
  confirmButtonLabel: string
  closeButtonLabel: string
  loading?: boolean
}

export default function ConfirmationWarnModal({
  title,
  description,
  isModalOpen,
  onModalClose,
  onModalConfirmation,
  confirmButtonLabel,
  closeButtonLabel,
  loading
}: Props) {
  return (
    <StyledModal isOpen={isModalOpen} onClose={onModalClose}>
      <h3>{title}</h3>
      <p>{description}</p>

      <div className="buttons">
        <Button secondary warning onClick={onModalConfirmation}>
          {loading ? <Spinner size={16} /> : confirmButtonLabel}
        </Button>

        <Button warning onClick={onModalClose}>
          {closeButtonLabel}
        </Button>
      </div>
    </StyledModal>
  )
}

const StyledModal = styled(Modal)`
  max-width: 868px;
  width: 100%;

  color: var(--white);
  background-color: var(--orange);

  p {
    max-width: 424px;
  }

  path {
    stroke: var(--white);
  }

  .buttons {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    max-width: 424px;
    width: 100%;

    margin-top: 8px;
    margin-bottom: 24px;

    button {
      width: 100%;
    }
  }
`
